// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row {
  align-items: center;
}

.header-row h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1c1c1c;
}

.back-btn {
  background: none;
  border: none;
  margin-left: -12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabs-container {
  display: flex;
  gap: 8px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 24px;
}

.tab {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 16px;
  color: #a4a4a4;
  font-weight: 400;
  position: relative;
}

.tab.active {
  color: #1c1c1c;
  font-weight: 600;
}

.status-label {
  padding: 4px 32px;
  border-radius: 24px;
  background-color: #fde3e3;
  color: #ff4747;
}

.status-label.issued {
  background-color: #daf2db;
  color: #178e1e;
}

mat-card {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
  border-radius: 8px !important;
  padding: 0 !important;
}

::ng-deep .mat-dialog-container {
  border-radius: 16px !important;
}

::ng-deep .mat-cell {
  color: #616161;
  font-weight: 400;
  font-size: 12px;
}

::ng-deep .mat-header-cell {
  color: #1c1c1c;
  font-weight: 600;
  font-size: 12px;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/employee-payment-log/employee-payment-log.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,wvFAAwvF","sourcesContent":[".header-row {\n  align-items: center;\n}\n\n.header-row h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1c1c1c;\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  margin-left: -12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tabs-container {\n  display: flex;\n  gap: 8px;\n  border-bottom: 1px solid #e0e0e0;\n  margin-bottom: 24px;\n}\n\n.tab {\n  padding: 12px 16px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #a4a4a4;\n  font-weight: 400;\n  position: relative;\n}\n\n.tab.active {\n  color: #1c1c1c;\n  font-weight: 600;\n}\n\n.status-label {\n  padding: 4px 32px;\n  border-radius: 24px;\n  background-color: #fde3e3;\n  color: #ff4747;\n}\n\n.status-label.issued {\n  background-color: #daf2db;\n  color: #178e1e;\n}\n\nmat-card {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n  border-radius: 8px !important;\n  padding: 0 !important;\n}\n\n::ng-deep .mat-dialog-container {\n  border-radius: 16px !important;\n}\n\n::ng-deep .mat-cell {\n  color: #616161;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n::ng-deep .mat-header-cell {\n  color: #1c1c1c;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
